// @flow

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { TextField, Button, Container, Typography, Box, Paper, Alert } from '@mui/material';
import { useAppContext } from '../context/AppContext';
import { TENANT } from '../constants';
import { useLanguage } from '../i18n';
import LanguageSelector from '../components/LanguageSelector';

const StartSaleOrderReturnRequestPage = (): any => {
    const { setState } = useAppContext();
    const { t } = useLanguage();
    const navigate = useNavigate();

    const [saleOrderNo, setSaleOrderNo] = useState('');
    const [phoneLast4, setPhoneLast4] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');

        try {
            const createSaleOrderReturnRequestResponse = await axios.post(
                '/api/v1/wms/saleorderreturnrequest/customer/saleOrderReturnRequests/create', 
                
                {
                    saleOrderNo,
                }, 
                
                {
                    headers: {
                        'X-Tenant': TENANT,
                        'X-Sale-Order-No': saleOrderNo,
                        'X-Phone-Last4': phoneLast4,
                    },
                }
            );

            const fetchSaleOrderReturnRequestItemsUrl = createSaleOrderReturnRequestResponse.data._links.searchSaleOrderReturnRequestLines.href
                    .replace('{text}', '')
                    .replace('{page}', '0')
                    .replace('{size}', '100');
            
            const fetchSaleOrderReturnRequestItemsResponse = await axios.get(
                fetchSaleOrderReturnRequestItemsUrl, 
                {
                    headers: {
                        'X-Tenant': TENANT,
                        'X-Sale-Order-No': saleOrderNo,
                        'X-Phone-Last4': phoneLast4,
                    },
                }
            );

            // On success, update app state
            setState({
                saleOrderNo,
                phoneLast4,
                returnRequest: createSaleOrderReturnRequestResponse.data,
                returnRequestLines: fetchSaleOrderReturnRequestItemsResponse.data?._embedded?.saleOrderReturnRequestLines,
            });

            console.log('Success:', createSaleOrderReturnRequestResponse.data);

            // Navigate to manage page
            navigate('/manage');
        } catch (err) {
            console.error(err);
            const errorData = err.response?.data;
            if (errorData?.causes && Array.isArray(errorData.causes)) {
                const messages = errorData.causes.map(cause => cause.message).join('; ');
                setError(messages);
            } else {
                setError(errorData?.message || t('errorOccurred'));
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5', py: 4 }}>
            <Container maxWidth="sm" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Paper elevation={3} sx={{ p: 4, width: '100%', maxWidth: 500 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                        <LanguageSelector />
                    </Box>
                    <Typography variant="h4" component="h1" gutterBottom align="center" color="primary">
                        {t('saleOrderReturnRequest')}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, textAlign: 'center' }}>
                        {t('startPageDescription')}
                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}
                    
                    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <TextField
                            fullWidth
                            label={t('saleOrderNumber')}
                            value={saleOrderNo}
                            onChange={(e) => setSaleOrderNo(e.target.value)}
                            margin="normal"
                            required
                            variant="outlined"
                        />
                        <TextField
                            fullWidth
                            label={t('last4DigitsPhone')}
                            value={phoneLast4}
                            onChange={(e) => setPhoneLast4(e.target.value)}
                            margin="normal"
                            inputProps={{ maxLength: 4 }}
                            required
                            variant="outlined"
                        />
                        <Button type="submit" variant="contained" color="primary" size="large" sx={{ mt: 2, py: 1.5 }} disabled={loading}>
                            {loading ? t('submitting') : t('submit')}
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
}

export default StartSaleOrderReturnRequestPage;
